import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-page',
  templateUrl: './skeleton-page.component.html',
  styleUrls: ['./skeleton-page.component.scss']
})
export class SkeletonPageComponent implements OnInit{

 
	@Input() height: string = '166px'
	@Input() type: string = 'table'


	streamsLeft = ['384px', '102px', '384px', '59px', '59px', '241px', '166px', '66px', '131px' ]
	streamsRight = ['384px', '67px', '167px', '235px', '219px', '65px']

	videosLeft = ['384px', '241px',  '59px','384px', '66px' ]
	videosRight = ['384px', '67px', '167px', '235px', '219px', '65px']

	playlistLeft = ['241px', '201px']
	playlistRight = ['66px', '59px', '167px']

        ngOnInit() { 
	}


}
